import { c as _c } from "react/compiler-runtime";
import { CheckboxField } from '@petsmart-ui/sparky';
import { useField, useFormikContext } from 'formik';
import type { AddPaymentFormInterface, EditPaymentFormInterface } from './schema';
export function IsDefaultCheckbox(t0) {
  const $ = _c(6);
  const {
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [t2] = useField("isPrimary");
  const {
    value
  } = t2;
  const {
    setFieldValue
  } = useFormikContext();
  let t3;
  if ($[0] !== setFieldValue) {
    t3 = value_0 => setFieldValue("isPrimary", value_0);
    $[0] = setFieldValue;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== disabled || $[3] !== t3 || $[4] !== value) {
    t4 = <CheckboxField className="sparky-u-margin-bottom-lg " hideLegend={true} label="Default payment method checkbox"><CheckboxField.Item text="Set as default payment method" name="isPrimary" checked={value} onChange={t3} disabled={disabled} /></CheckboxField>;
    $[2] = disabled;
    $[3] = t3;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}